import ApiService from '../../../../shared/services/ApiService';

export default {
    getDownloadReport(memberId, from, to, department = '', deleted = false){
        const date = new Date();
        const time = date.getMilliseconds();
        return ApiService.downloadFile(`/web-download-reports?from=${from}&to=${to}&member=${memberId}&department=${department}&time=${time}&deleted=${deleted}`);
    },
    getDownloadJobCodeReport(memberId, from, to, deleted){
        const date = new Date();
        const time = date.getMilliseconds();
        return ApiService.downloadFile(`/web-download-job-codes?from=${from}&to=${to}&member=${memberId}&time=${time}&deleted=${deleted}`);
    },
}